import { Box, IconButton, IconButtonProps } from '@chakra-ui/react';
import { buildSocialUrls } from '@waitroom/common';
import { SocialLink, SocialName, Socials } from '@waitroom/models';
import * as React from 'react';
import { getIcon, icons } from '../../../../../constants/brand';

const buttonProps = {
  isRound: true,
  boxShadow: 'none',
};

export interface SocialLinksProps {
  links?: SocialLink[];
  styles?: Partial<IconButtonProps>;
}

const SocialLinks = ({ links = [], styles }: SocialLinksProps): React.ReactElement | null => (
  <>
    {links
      ? buildSocialUrls(links)?.map((link, i) => {
          const { platform = '', url } = link;
          const type = platform.toLowerCase() as SocialName;
          if (!Socials[type] || !url) return null;
          const href = type === 'email' && !url.startsWith('mailto:') ? `mailto:${url}` : url;

          return (
            <Box key={i}>
              <a
                href={href}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="none"
                title={type}
              >
                <IconButton {...buttonProps} aria-label={type} fontSize="lg" {...styles}>
                  {getIcon(icons[type])}
                </IconButton>
              </a>
            </Box>
          );
        })
      : null}
  </>
);

export default SocialLinks;
